import React from 'react';
import { CodeBlock } from '@cimpress/react-components';
import CodeBlockCode from '!raw-loader!./codeBlock.jsx';

const CodeBlockDemo = () => (
  <div>
    <div className="row">
      <div className="col-md-6">
        <h5>Sample non-JavaScript code</h5>
        <CodeBlock code="npm i @cimpress/react-components" />
      </div>
      <div className="col-md-6">
        <h5>Sample non-JavaScript code</h5>
        <CodeBlock code="yarn add @cimpress/react-components" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <h5>Sample JavaScript code</h5>
        <CodeBlock code={CodeBlockCode} />
      </div>
    </div>
  </div>
);

export default CodeBlockDemo;
